import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import "@/App.css";
import SmoothScroll from "@/components/layout/SmoothScroll";
import AnnouncementBar from "@/components/layout/AnnouncementBar";
import BetaThanksToast from "@/components/layout/BetaThanksToast";
import StickyCTA from "@/components/layout/StickyCTA";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import PageLoader from "@/components/layout/PageLoader";
import CookieBanner from "@/components/layout/CookieBanner";
import LanguageDetectedBanner from "@/components/layout/LanguageDetectedBanner";
import LaunchToast from "@/components/layout/LaunchToast";
import { LanguageProvider } from "@/i18n/LanguageProvider";
import HomePage from "@/pages/Home";
import HowItWorks from "@/pages/HowItWorks";
import Fees from "@/pages/Fees";
import Countries from "@/pages/Countries";
import Security from "@/pages/Security";
import FAQ from "@/pages/FAQ";
import Waitlist from "@/pages/Waitlist";
import Contact from "@/pages/Contact";
import Founders from "@/pages/Founders";
import About from "@/pages/About";
import PublicHandle from "@/pages/PublicHandle";
import Press from "@/pages/Press";
import CorridorDetail from "@/pages/CorridorDetail";
import AdminSources from "@/pages/AdminSources";
import AdminSignalRoom from "@/pages/AdminSignalRoom";
import Terms from "@/pages/legal/Terms";
import Privacy from "@/pages/legal/Privacy";
import AMLKYC from "@/pages/legal/AMLKYC";
import Cookies from "@/pages/legal/Cookies";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}

const ROUTES = [
  { path: "/", element: <HomePage /> },
  { path: "/about", element: <About /> },
  { path: "/how-it-works", element: <HowItWorks /> },
  { path: "/fees", element: <Fees /> },
  { path: "/countries", element: <Countries /> },
  { path: "/security", element: <Security /> },
  { path: "/faq", element: <FAQ /> },
  { path: "/waitlist", element: <Waitlist /> },
  { path: "/contact", element: <Contact /> },
  { path: "/founders", element: <Founders /> },
  { path: "/founders/:handle", element: <PublicHandle /> },
  { path: "/press", element: <Press /> },
  { path: "/corridors/:slug", element: <CorridorDetail /> },
  { path: "/admin/sources", element: <AdminSources /> },
  { path: "/admin/signal-room", element: <AdminSignalRoom /> },
  { path: "/legal/terms", element: <Terms /> },
  { path: "/legal/privacy", element: <Privacy /> },
  { path: "/legal/aml-kyc", element: <AMLKYC /> },
  { path: "/legal/cookies", element: <Cookies /> },
];

function LocalizedRoutes() {
  return (
    <Routes>
      {ROUTES.map((r) => (
        <Route key={r.path} path={r.path} element={r.element} />
      ))}
      {ROUTES.map((r) => (
        <Route
          key={`fr${r.path}`}
          path={`/fr${r.path === "/" ? "" : r.path}`}
          element={r.element}
        />
      ))}
      {ROUTES.map((r) => (
        <Route
          key={`pt${r.path}`}
          path={`/pt${r.path === "/" ? "" : r.path}`}
          element={r.element}
        />
      ))}
      <Route path="*" element={<HomePage />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App min-h-screen bg-canvas text-ink font-sans">
      <HelmetProvider>
        <PageLoader />
        <BrowserRouter>
        <LanguageProvider>
        <SmoothScroll>
          <ScrollToTop />
          <LanguageDetectedBanner />
          <AnnouncementBar />
          <Header />
          <LocalizedRoutes />
          <Footer />
          <StickyCTA />
          <BetaThanksToast />
          <LaunchToast />
          <CookieBanner />
        </SmoothScroll>
        </LanguageProvider>
      </BrowserRouter>
      </HelmetProvider>
    </div>
  );
}

export default App;
